import React from 'react';

import { FloatingElements } from './FloatingElements';
import type { ITariffCardReactModel } from '../types';

export function withFloatingElements(WrappedComponent: React.ComponentType<ITariffCardReactModel>) {
  return (props: ITariffCardReactModel) => (
    <>
      <WrappedComponent {...props} />
      <FloatingElements {...props} />
    </>
  );
}
